export enum VehicleAction {
  CREATE = 'crear',
  UPDATE = 'actualizar',
}
